import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const TelegramIcon: React.FC<SvgProps> = ({ color, ...props }) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        id="Vector"
        d="M12.5 1C6.152 1 1 6.152 1 12.5C1 18.848 6.152 24 12.5 24C18.848 24 24 18.848 24 12.5C24 6.152 18.848 1 12.5 1ZM17.836 8.82C17.6635 10.637 16.916 15.053 16.5365 17.0885C16.3755 17.951 16.0535 18.2385 15.7545 18.273C15.0875 18.3305 14.5815 17.836 13.9375 17.4105C12.9255 16.7435 12.3505 16.3295 11.373 15.6855C10.2345 14.938 10.9705 14.524 11.626 13.857C11.7985 13.6845 14.7425 11.005 14.8 10.7635C14.808 10.7269 14.8069 10.6889 14.7969 10.6529C14.7869 10.6168 14.7682 10.5837 14.7425 10.5565C14.6735 10.499 14.5815 10.522 14.501 10.5335C14.3975 10.5565 12.7875 11.626 9.648 13.742C9.188 14.0525 8.774 14.2135 8.406 14.202C7.992 14.1905 7.21 13.972 6.6235 13.7765C5.899 13.5465 5.3355 13.42 5.3815 13.0175C5.4045 12.8105 5.692 12.6035 6.2325 12.385C9.5905 10.9245 11.8215 9.9585 12.937 9.4985C16.134 8.1645 16.7895 7.9345 17.2265 7.9345C17.3185 7.9345 17.537 7.9575 17.675 8.0725C17.79 8.1645 17.8245 8.291 17.836 8.383C17.8245 8.452 17.8475 8.659 17.836 8.82Z"
        fill={color || '#999999'}
      />
    </Svg>
  )
}

export default TelegramIcon
